import { Component } from 'react';
import classNames from 'classnames';
import MUITextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import { color } from '../../app/theme';

const useStyles = theme => ({
  body2: {
    ...theme.typography.body2,
    marginRight: '8px',
    color: color.$10,
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '22px',
    alignItems: 'center',
    ...theme.input.default.wrapper,
  },
  root: {
    overflowX: 'auto',
    overflowY: 'hidden',
    display: 'flex',
    alignItems: 'center',
    height: '42px',
    borderRadius: '22px',
  },
  multiline: {
    overflowX: 'hidden',
    overflowY: 'hidden',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '22px',
    padding: '0px',
  },
  input: {
    color: color.$3,
    WebkitTextFillColor: color.$3,
    padding: '12px 24px',
    '&::placeholder': {
      color: color.$10,
      WebkitTextFillColor: color.$10,
      lineHeight: '21px',
      fontWeight: 'normal',
      opacity: 1,
    },
  },
  urlInput: {
    ...theme.input.default.input,
    padding: '12px 0px 12px 16px',
    lineHeight: '21px',
    '&::placeholder': {
      transform: 'translateY(1%)',
    },
  },
  pathInput: {
    ...theme.input.default.input,
    padding: '12px 16px',
    lineHeight: '21px',
    '&::placeholder': {
      transform: 'translateY(1%)',
    },
  },
  cardInput: {
    ...theme.input.default.input,
    padding: '12px 16px 11px',
    lineHeight: '21px',
    '&::placeholder': {
      transform: 'translateY(1%)',
    },
  },
  defaultRoot: {
    ...theme.input.default.root,
  },
  defaultInput: {
    ...theme.input.default.input,
  },
  disableInput: {
    ...theme.input.default.input,
    color: '#bdbdbd',
    WebkitTextFillColor: '#bdbdbd',
  },
  textFieldCardInput: {
    ...theme.input.default.input,
    padding: '12px 16px',
  },
  error: {
    border: `1px solid ${color.$17}`,
  },
  errorText: {
    textAlign: 'end',
    ...theme.typography.body1,
    color: color.$17,
    marginTop: '12px',
  },
  disabledInputWrapper: {
    border: 'solid 1px #e0e0e0',
  },
});
class Input extends Component {
  constructor() {
    super();
    this.state = {
      isFocus: false,
      inputValid: undefined,
    };
  }

  render() {
    const {
      classes,
      className,
      style,
      InputProps,
      topic,
      onChange,
      inputRef,
      multiline,
      disabled,
      enableUnderline,
      valid,
      placeholder,
      select,
      min,
      MenuItems,
      selectprops,
      isError,
      errorText,
      enableError,
      wordCount,
      limit,
      inputProps,
      ...props
    } = this.props;
    const { isFocus } = this.state;
    const root = !multiline ? classes.root : classes.multiline;
    return (
      <>
        <MUITextField
          className={classNames(
            [
              className,
              classes.inputWrapper,
              ...(this.state.inputValid !== undefined
                ? [valid ? 'valid' : 'invalid']
                : []),
              ...(this.props.error !== undefined
                ? [
                    this.props.error
                      ? 'invalid'
                      : this.state.inputValid !== undefined
                      ? 'valid'
                      : undefined,
                  ]
                : []),
            ],
            {
              focus: isFocus,
              [classes.disabledInputWrapper]: disabled,
              [classes.error]: isError,
            },
          )}
          style={style}
          disabled={disabled}
          multiline={multiline}
          select={select}
          fullWidth
          inputRef={inputRef}
          selectprops={selectprops}
          InputProps={{
            disableUnderline: !enableUnderline,
            placeholder,
            classes: {
              root: classNames(root, classes[`${topic}Root`]),
              input: classNames([
                classes.input,
                classes[`${topic}Input`],
                disabled && classes.disableInput,
              ]),
            },
            onChange,
            inputProps: {
              min,
              onFocus: () => {
                if (InputProps) {
                  if (InputProps.onFocus) {
                    InputProps.onFocus();
                  }
                }
                this.setState(
                  () => ({ isFocus: true }),
                  () => {
                    if (valid !== undefined) {
                      this.setState({
                        inputValid: valid ? 'valid' : 'invalid',
                      });
                    } else {
                      this.setState({ isFocus: false });
                    }
                  },
                );
              },
              onBlur: e => {
                if (InputProps) {
                  if (InputProps.onBlur) {
                    InputProps.onBlur(e);
                  }
                }
                this.setState(
                  () => ({ isFocus: false }),
                  () => {
                    this.setState({ inputValid: undefined });
                  },
                );
              },
              ...this.props.inputProps,
            },
            endAdornment: limit && (
              <InputAdornment className={classes.body2} position="end">
                <span>{`${wordCount}/${limit}`}</span>
              </InputAdornment>
            ),
            ...InputProps,
          }}
          {...props}
        >
          {MenuItems
            ? MenuItems.map(option => {
                return (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                );
              })
            : null}
        </MUITextField>
        {enableError && <div className={classes.errorText}>{errorText}</div>}
      </>
    );
  }
}

Input.defaultProps = {
  enableUnderline: false,
  wordCount: 0,
};

export default withStyles(useStyles)(Input);
